"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PlaceTableSorter_1 = require("@/pages/place/components/PlaceTableSorter");
var PlaceTable_1 = require("@/pages/place/components/PlaceTable");
var PlaceFollowButton_1 = require("@/pages/place/components/PlaceFollowButton");
var react_redux_1 = require("react-redux");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var mapStateToProps = function (state, ownProp) { return (__assign({}, ownProp)); };
var mapDispatchToProps = function (dispatch) { return ({
    toggleSort: function (type, filterType) {
        return dispatch(PlaceAction_1.default.onToggleSort(type, filterType));
    },
    propertyLinkClicked: function (link) {
        return dispatch(PlaceAction_1.default.propertyLinkClicked(link));
    },
    propertyEnquireClicked: function (item) {
        return dispatch(PlaceAction_1.default.propertyEnquireClicked(item));
    },
    followClicked: function () { return dispatch(PlaceAction_1.default.followClicked()); },
    unfollowClicked: function () { return dispatch(PlaceAction_1.default.unfollowClicked()); },
    favClicked: function (item) { return dispatch(PlaceAction_1.default.favClicked(item)); },
    onSortUpdateCompleted: function () { return dispatch(PlaceAction_1.default.onSortUpdateCompleted()); },
}); };
var placeResultListItemsFc = function (props) {
    var renderEmpty = function (props) {
        var title = props.t.noAvailableListingTitle;
        var caption = props.t.noAvailableListingCaption;
        return (React.createElement("div", { className: "c-jumbo c-jumbo__column c-jumbo--lift", style: { marginTop: "20px" } },
            React.createElement("div", { className: "c-jumbo__img" },
                React.createElement("img", { src: "/res/img/404.jpg" })),
            React.createElement("div", { className: "c-jumbo__main" },
                React.createElement("div", { className: "c-jumbo__header" },
                    React.createElement("div", { className: "c-jumbo__header-main" },
                        React.createElement("div", { className: "c-jumbo__title" }, title),
                        React.createElement("div", { className: "c-jumbo__caption" }, caption))),
                React.createElement("div", { className: "c-jumbo__body" },
                    React.createElement("div", { className: "c-jumbo__content" },
                        React.createElement("div", { className: "c-jumbo__content-row" }, props.t.noAvailableListingBody)),
                    React.createElement("div", { className: "c-jumbo__actions" },
                        React.createElement(PlaceFollowButton_1.placeFollowButton, __assign({}, props)))))));
    };
    if (!props.results || !props.results.length)
        return renderEmpty(props);
    var results = props.results
        .sort(PlaceTableSorter_1.sorter(props.currentSort, props.currentOrder))
        .sort(PlaceTableSorter_1.sortDownZero(props.currentSort));
    return (React.createElement("div", { className: "c-tableview__section" },
        React.createElement("table", { className: "c-tableview__body" },
            React.createElement("thead", null, PlaceTable_1.renderTableHeads(props)),
            React.createElement("tbody", null, results.map(function (it, i) { return PlaceTable_1.renderTableRow(props, it, i); })))));
};
var placeResultListItems = function (props) {
    React.useEffect(function () {
        props.onSortUpdateCompleted();
    });
    return placeResultListItemsFc(props);
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(placeResultListItems);
